import React, { useEffect, useState } from 'react';
import './PendingAffiliateRequests.scss';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import { http, localstorage, useNavigationService } from '../../fx-core';
import nostalls from '../../../assets/nostalls.svg';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';

const getLoggedInMerchantId = (): number => {
  const val = localstorage.getItem('userId');
  const parsed = parseInt(val, 10);
  return !isNaN(parsed) && parsed > 0 ? parsed : 0;
};

const PendingAffiliateRequests = (props: any) => {
  const { navigateRoot, back } = useNavigationService();
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [dateFilter, setDateFilter] = useState<'all' | 'today' | 'week' | 'month' | 'year'>('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const quickFilters = [
    { key: 'all' as const, label: 'All Time', icon: 'fa-infinity' },
    { key: 'today' as const, label: 'Today', icon: 'fa-calendar-day' },
    { key: 'week' as const, label: 'This Week', icon: 'fa-calendar-week' },
    { key: 'month' as const, label: 'This Month', icon: 'fa-calendar-alt' },
    { key: 'year' as const, label: 'This Year', icon: 'fa-calendar' },
  ];

  const navToDashboard = () => {
    back();
  };

  const formatUtcDate = (raw: string) => {
    if (!raw) return 'N/A';
    const isoWithZ = /Z|[+-]\d{2}:\d{2}$/.test(raw) ? raw : raw + 'Z';
    return new Date(isoWithZ).toLocaleString('en-IN', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
  };

  const getPendingRequests = () => {
    setLoading(true);
    let apiOptions: any = {
      url: `affiliate-product/my-requests`
    };
    http.get(apiOptions).then((response: any) => {
      const result = response?.data || [];
      setRequests(result);
      setLoading(false);
    }).catch(() => {
      setRequests([]);
      setLoading(false);
    });
  };

  const filteredRequests = requests.filter((r: any) => {
    const raw = r.createdDate || r.CreatedDate;
    if (!raw) return dateFilter === 'all' && !fromDate && !toDate;
    const isoWithZ = /Z|[+-]\d{2}:\d{2}$/.test(raw) ? raw : raw + 'Z';
    const d = new Date(isoWithZ);

    if (fromDate || toDate) {
      if (fromDate) {
        const start = new Date(fromDate);
        start.setHours(0, 0, 0, 0);
        if (d < start) return false;
      }
      if (toDate) {
        const end = new Date(toDate);
        end.setHours(23, 59, 59, 999);
        if (d > end) return false;
      }
      return true;
    }

    if (dateFilter === 'all') return true;
    const now = new Date();
    let cutoff: Date;
    if (dateFilter === 'today') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    } else if (dateFilter === 'week') {
      cutoff = new Date(now);
      cutoff.setDate(now.getDate() - 7);
    } else if (dateFilter === 'month') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), 1);
    } else if (dateFilter === 'year') {
      cutoff = new Date(now.getFullYear(), 0, 1);
    } else {
      cutoff = new Date(now.getFullYear(), now.getMonth(), 1);
    }
    return d >= cutoff;
  });

   const updateRequestStatus = (id: number, status: 'Accepted' | 'Rejected') => {
    let apiOptions: any = {
      url: 'affiliate-product/update-status',
      data: { Id: id, Status: status }
    };
    http.post(apiOptions).then(() => {
      setRequests((prev: any[]) =>
        prev.map((r: any) => (r.id === id ? { ...r, requestStatus: status } : r))
      );
    }).catch((err: any) => {
      console.error('Failed to update status:', err);
    });
  };

  useEffect(() => {
    getPendingRequests();
  }, []);

  return (
    <div className="pendingaffiliaterequests-ui" style={{ paddingTop: '85px' }}>
      <div className="pt-3 px-4" style={{ backgroundColor: '#f5f1e8' }}>
        <Breadcrumbs aria-label="breadcrumb">
                    <span
            className="pointer"
            style={{ color: '#f69516', textDecoration: 'underline', fontWeight: 'bold' }}
            onClick={() => navigateRoot({ targetRoute: '/provider/affiliatedashboard', targetTitle: "Affiliate Dashboard", targetData: {}, sourceState: {}, eventSource: '' })}
          >
            Dashboard
          </span>
          <Typography style={{ color: '#3c4858', fontWeight: 500 }}>Pending Affiliate Requests</Typography>
        </Breadcrumbs>
      </div>

      <div className="px-4 pt-3">
        <div className="filter-pill-row">
          {quickFilters.map((f) => (
            <button
              key={f.key}
              className={'filter-pill' + (dateFilter === f.key ? ' active' : '')}
              onClick={() => { setDateFilter(f.key); setFromDate(''); setToDate(''); }}
            >
              <i className={`fas ${f.icon}`}></i>{f.label}
            </button>
          ))}

          <div className="filter-pill-divider"></div>

          <div className="custom-range-inline">
            <i className="fas fa-calendar-alt custom-range-icon"></i>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              title="From"
            />
            <span className="custom-range-sep">→</span>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              title="To"
            />
            <button
              className={'filter-pill custom-range-apply-pill' + (fromDate || toDate ? ' active' : '')}
              disabled={!fromDate && !toDate}
              onClick={() => setDateFilter('all')}
            >
              Apply
            </button>
          </div>
        </div>
      </div>

      <div className="pt-4 px-3">
        {loading &&
          <div className="py-5 text-center">
            <CircularProgress />
          </div>
        }

        {!loading && filteredRequests.length < 1 &&
          <div className="py-5 text-center">
            <img src={nostalls} alt="no requests"></img>
            <div className="pt-4 font-17"><b>No requests in this period.</b></div>
          </div>
        }

        {!loading && filteredRequests.length > 0 &&
          <div className="row">
            {filteredRequests.map((row: any, i: number) => (
              <div className="col-12 col-md-6 col-lg-4 pb-3" key={row.id || i}>
                <Card className="p-3 request-card">
                  <div className="font-18"><b>{row.itemName}</b></div>
                  <div className="pt-2 font-14 text-muted">
                    Requested by: <b>{row.resellerName || ('Reseller #' + row.resellerId)}</b>
                  </div>
                  <div className="pt-1 font-14 text-muted">
                    Proposed commission: <b>{row.marginNumber}%</b>
                  </div>
                  <div className="pt-2 d-flex align-items-center justify-content-between">
                                        <span
                      className="status-badge font-12 px-2 py-1"
                      style={
                        row.requestStatus === 'Accepted'
                          ? { background: '#e8f5e9', color: '#2e7d32' }
                          : row.requestStatus === 'Rejected'
                          ? { background: '#ffebee', color: '#c62828' }
                          : { background: '#fff3e0', color: '#f69516' }
                      }
                    >
                      {row.requestStatus || 'Pending'}
                    </span>
                    {(row.requestStatus === 'Pending' || !row.requestStatus) && (
                      <div>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          style={{ marginRight: 8 }}
                          onClick={() => updateRequestStatus(row.id, 'Accepted')}
                        >
                          Accept
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => updateRequestStatus(row.id, 'Rejected')}
                        >
                          Reject
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 text-left">
                      <span
                        className="pointer"
                        style={{ color: '#f69516', textDecoration: 'underline', fontSize: '12px' }}
                        onClick={() => { setSelectedMerchant(row); setDetailsOpen(true); }}
                      >
                        View Details
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        }
      </div>
      <Dialog open={detailsOpen} onClose={() => setDetailsOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Merchant Details</DialogTitle>
        <DialogContent>
          <p><strong>Reseller Name:</strong> {selectedMerchant?.resellerName || 'N/A'}</p>
          <p><strong>Reseller Mobile:</strong> {selectedMerchant?.resellerMobile || 'N/A'}</p>
          <p><strong>Reseller Email:</strong> {selectedMerchant?.resellerEmail || 'N/A'}</p>
          <p><strong>Item:</strong> {selectedMerchant?.itemName}</p>
          <p><strong>Request Date:</strong> {formatUtcDate(selectedMerchant?.createdDate || selectedMerchant?.CreatedDate)}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailsOpen(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PendingAffiliateRequests;